<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form
        ref="form"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="campaigns.quietHoursEnabled"
              label="Тихие часы включены"
              hint="Рассылка, назначенная на тихие часы, ждёт их конца. Время — по Бишкеку."
              persistent-hint
              class="mt-0"
            ></v-switch>
          </v-col>

          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="campaigns.quietFrom"
              label="С"
              type="time"
              dense
              outlined
              :rules="timeRules"
              :error-messages="messages('quietFrom')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="campaigns.quietTo"
              label="До"
              type="time"
              dense
              outlined
              :rules="timeRules"
              :error-messages="messages('quietTo')"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              :loading="saving === 'campaigns'"
              :disabled="hasNotPermission('Permissions.NotificationSettingsUpdate')"
              @click="saveData"
            >
              Сохранить
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'
import { errorMessages, hasPermission } from '@/helpers'

export default {
  name: 'CampaignSettingForm',
  computed: {
    ...mapFormHandlers('notificationSettings', [
      'campaigns.quietHoursEnabled',
      'campaigns.quietFrom',
      'campaigns.quietTo',
    ]),
    ...mapState('notificationSettings', ['saving']),
    ...mapGetters('notificationSettings', ['errorsOf']),

    timeRules() {
      return this.campaigns.quietHoursEnabled ? [rules.required] : []
    },
  },
  methods: {
    ...mapActions('notificationSettings', ['update']),
    hasNotPermission(value) {
      return !hasPermission(value)
    },
    messages(property) {
      return errorMessages(this.errorsOf('campaigns'), property)
    },
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.update('campaigns')
      }
    },
  },
}
</script>
